import { createSlice } from "@reduxjs/toolkit";

const metadataSlice = createSlice({
  name: "metadata",
  initialState: {},
  reducers: {
    setMetadata: (state, action) => action.payload,
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = metadataSlice;

// Extract and export each action creator by name
export const { setMetadata } = actions;

// Export the reducer, either as a default or named export
export default reducer;
